import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=9757b922&scoped=true"
import script from "./Blank.vue?vue&type=script&lang=ts"
export * from "./Blank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9757b922",
  null
  
)

export default component.exports